import React from 'react';
import { Wifi, WifiOff, Loader2, HardDriveDownload, UploadCloud, AlertTriangle } from 'lucide-react';

// Iter 99 · Indicador PERMANENTE de conexión para el formulario del auditor.
// Iter 108 (Fase A) · Sin señal ya NO decimos "no se está guardando": el avance
// se persiste localmente (IndexedDB). Reflejamos también sincronización/pendientes.
// Diseñado para lectura en campo: tablet a plena luz, auditor de pie.
export function ConnectionIndicator({ status, offlinePending = false, syncing = false, syncError = null, photoProgress = null }) {
    if (status === 'online') {
        // En línea pero con avance pendiente por subir o sincronizando.
        if (syncing) {
            return (
                <span
                    data-testid="connection-indicator" data-status="online" data-sync="syncing"
                    className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-semibold rounded-full"
                    style={{ background: 'rgba(37,99,235,0.12)', color: '#1D4ED8', border: '1px solid rgba(37,99,235,0.35)' }}
                >
                    <UploadCloud className="w-4 h-4 animate-pulse" />
                    {photoProgress ? `Subiendo ${photoProgress.done} de ${photoProgress.total} fotos…` : 'Sincronizando tu avance…'}
                </span>
            );
        }
        if (syncError) {
            return (
                <span
                    data-testid="connection-indicator" data-status="online" data-sync="error"
                    className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-bold rounded-full"
                    style={{ background: 'rgba(245,158,11,0.15)', color: '#B45309', border: '1px solid rgba(245,158,11,0.45)' }}
                >
                    <AlertTriangle className="w-4 h-4" /> Falló la subida — reintentando…
                </span>
            );
        }
        return (
            <span
                data-testid="connection-indicator" data-status="online"
                className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-semibold rounded-full"
                style={{ background: 'rgba(16,185,129,0.12)', color: '#047857', border: '1px solid rgba(16,185,129,0.35)' }}
            >
                <Wifi className="w-4 h-4" /> En línea
            </span>
        );
    }
    if (status === 'checking') {
        return (
            <span
                data-testid="connection-indicator" data-status="checking"
                className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-semibold rounded-full"
                style={{ background: 'rgba(107,114,128,0.12)', color: '#374151', border: '1px solid rgba(107,114,128,0.35)' }}
            >
                <Loader2 className="w-4 h-4 animate-spin" /> Verificando conexión…
            </span>
        );
    }
    // offline — Fase A: avance guardado localmente. Alto contraste, texto grande.
    return (
        <span
            data-testid="connection-indicator" data-status="offline" data-offline-saved="true"
            role="alert"
            className="inline-flex items-center gap-2 px-4 py-2 text-base font-extrabold rounded-md text-white shadow-md"
            style={{ background: '#B45309', border: '2px solid #92400E', letterSpacing: '0.01em' }}
        >
            <WifiOff className="w-5 h-5 shrink-0" />
            <HardDriveDownload className="w-5 h-5 shrink-0" />
            Sin conexión — tu avance se guarda en este dispositivo
        </span>
    );
}

export default ConnectionIndicator;
